// Used in notifications.component.html

// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
// Services/Types/Helpers
import { Notification } from "cli-types";

// Moment
import { DateString } from "@carnegie-learning/utility-types";
import moment from "moment";

@Component({
    selector: "notifications-list",
    templateUrl: "./notifications-list.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./notifications-list.component.scss",
    ],
    standalone: false
})
export class NotificationsListComponent implements OnInit {
    @Input() public notifications?: Notification[];

    @Output() markAsRead = new EventEmitter<Notification>();

    @Output() archive = new EventEmitter<Notification>();
    @Output() restore = new EventEmitter<Notification>();

    @Output() sendReplyEvent = new EventEmitter<Notification>();

    replyWindowOpen = false;
    notificationsLoaded = false;

    constructor() {}

    ngOnInit() {
        this.notificationsLoaded = !!this.notifications;
    }

    formatDate(date: DateString) {
        if (!date) {
            return "N/A";
        }
        return moment(date).format("MM/DD/YYYY");
    }

    onClickMarkAsRead(notification: Notification) {
        this.markAsRead.emit(notification);
        this.replyWindowOpen = false;
    }

    onClickMarkAsArchived(notification: Notification) {
        this.archive.emit(notification);
    }

    onClickRestore(notification: Notification) {
        this.restore.emit(notification);
    }

    onClickReplyToMessage() {
        this.replyWindowOpen = true;
    }

    onClickCancelReply() {
        this.replyWindowOpen = false;
    }

    replyButtonPresence(note: Notification): boolean {
        return !!(note.type === "pm");
    }

    sendReply(event: Notification) {
        this.sendReplyEvent.emit(event);
        this.replyWindowOpen = false;
    }
}
